import { Link } from 'react-router-dom';

interface ArticleCardProps {
  title: string;
  slug: string;
  category: string;
  categoryName: string;
  excerpt: string;
  coverImage: string;
  publishDate: string;
  readTime: string;
  featured?: boolean;
  tags?: string[];
}

export default function ArticleCard({
  title,
  slug,
  category,
  categoryName,
  excerpt,
  coverImage,
  publishDate,
  readTime,
  featured,
}: ArticleCardProps) {
  return (
    <article className="group">
      <Link to={`/article/${slug}`} className="block">
        <div className={`relative overflow-hidden rounded-lg ${featured ? 'aspect-[16/9]' : 'aspect-[16/10]'} mb-4`}>
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading={featured ? undefined : 'lazy'}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
          <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium rounded-full bg-background-50/90 text-primary-600">
            {categoryName}
          </span>
        </div>

        <div className="space-y-2">
          <h3
            className={`font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 ${
              featured ? 'text-lg md:text-xl' : 'text-base'
            }`}
          >
            {title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
            {excerpt}
          </p>
          <div className="flex items-center gap-3 text-xs text-foreground-500 pt-1">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line text-xs"></i>
              {publishDate}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line text-xs"></i>
              {readTime}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}